import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface EOptions extends Options {
  appendSymbolToMax: string,
  appendSymbolToMin: string
}

export interface RangeValues {
  lowValue: number;
  highValue: number;
}

@Component({
  selector: 'app-extended-slider',
  templateUrl: './extended-slider.component.html',
  styleUrls: ['./extended-slider.component.scss']
})
export class ExtendedSliderComponent implements OnInit {
  @Input('userMin') lowValue: number;
  @Input('userMax') highValue: number = null;
  @Input('min') floorValue: number = 0;
  @Input('max') ceilValue: number = 100;
  @Input('appendMax') appendSymbolToMax: string = null;
  @Input('appendMin') appendSymbolToMin: string = null;
  @Output('change') change: EventEmitter<RangeValues> = new EventEmitter<RangeValues>();


  options: EOptions = {
    floor: this.floorValue,
    ceil: this.ceilValue,
    appendSymbolToMax: this.appendSymbolToMax,
    appendSymbolToMin: this.appendSymbolToMin,
    translate: function (value, label) {
      if(this.appendSymbolToMax && label == LabelType.Ceil || (label == LabelType.High && this.ceil == value)) return `${value.toString()}${this.appendSymbolToMax}`;
      if(this.appendSymbolToMin && label == LabelType.High || (label == LabelType.Ceil && this.ceil == value)) return `${value.toString()}${this.appendSymbolToMin}`;
      return value.toString();
    },
    combineLabels: function(minLabel, maxLabel) {
      if(minLabel ==  maxLabel.replace(/\+$/g, '')) return maxLabel;
      return `${minLabel}-${maxLabel}`
    }
  };
  
  constructor() { }

  ngOnInit() {
    this.options.floor = this.floorValue;
    this.options.ceil = this.ceilValue;

    this.options.appendSymbolToMax = this.appendSymbolToMax;
    this.options.appendSymbolToMin = this.appendSymbolToMin;
  }

  changeEvent(event) {
    this.change.emit({ highValue: event.highValue, lowValue: event.value });
  }
}
